'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatAvatar = require('ui-addon-messages/avatar/ChatAvatar');

var _ChatAvatar2 = _interopRequireDefault(_ChatAvatar);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLTIP_HOVER_DELAY = 1000;

var CompanyAvatar = function (_Component) {
  _inherits(CompanyAvatar, _Component);

  function CompanyAvatar() {
    _classCallCheck(this, CompanyAvatar);

    return _possibleConstructorReturn(this, (CompanyAvatar.__proto__ || Object.getPrototypeOf(CompanyAvatar)).apply(this, arguments));
  }

  _createClass(CompanyAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isLastInGroup = _props.isLastInGroup,
          name = _props.name,
          showNameTooltip = _props.showNameTooltip,
          size = _props.size,
          src = _props.src,
          tooltipPlacement = _props.tooltipPlacement;


      if (!isLastInGroup) {
        return _react2.default.createElement('div', { className: 'p-x-3' });
      }

      return _react2.default.createElement(
        _UITooltip2.default,
        {
          delay: TOOLTIP_HOVER_DELAY,
          disabled: !showNameTooltip,
          title: name,
          placement: tooltipPlacement
        },
        _react2.default.createElement(_ChatAvatar2.default, { className: className, size: size, src: src })
      );
    }
  }]);

  return CompanyAvatar;
}(_react.Component);

CompanyAvatar.propTypes = {
  className: _react.PropTypes.string.isRequired,
  isLastInGroup: _react.PropTypes.bool,
  name: _react.PropTypes.string,
  showNameTooltip: _react.PropTypes.bool,
  size: _react.PropTypes.string.isRequired,
  src: _react.PropTypes.string,
  tooltipPlacement: _react.PropTypes.string
};

CompanyAvatar.defaultProps = {
  className: '',
  size: 'extra-small',
  showNameTooltip: false
};

exports.default = CompanyAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/CompanyAvatar.js
// module id = 1143
// module chunks = 2 3